import * as types from '../constants/ActionTypes';

export const setFiltrosBusqueda = filtros => dispatch => {
  dispatch({
    type: types.SET_FILTROS,
    payload: {
      filtros,
    },
  });
};
